import React, { useEffect, useState } from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { useParams } from "react-router-dom";
import { CircularProgress, LinearProgress } from "@mui/material";
import { FormEditMarketer } from "./FormEditMarketer";

export const PanelEditMarketer = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({
      name: "",
      platform: "",
      identifier: "",
      default_message: "",
  });
  const getData = async () => {
    try {
      const { result, response } = await Helper.Get({
        url: `${api_Routes.Marketers.GetOne}/${id}`,
      });

      if (response) {
        setData({
          name: response.data.name || "",
            platform: response.data.platform || "",
            identifier: response.data.identifier || "",
            default_message: response.data.default_message || "",
        });
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      {" "}
      <PanelHead
        title={
          isLoading ? (
            <div className="flex items-center gap-4">
              Edit Marketer <CircularProgress size={24} />
            </div>
          ) : (
            <div className="flex items-center justify-between w-full gap-4">
              <div>Edit Marketer: {data?.title}</div>
            </div>
          )
        }
      />
      <PanelBody
        content={
          isLoading ? (
            <LinearProgress />
          ) : (
            <FormEditMarketer data={data} setData={setData} />
          )
        }
      />
    </div>
  );
};
